import styled from "styled-components";
import breakpoints from "../../../styles/breakpoints";
import { safeAreaTopPaddingPlus } from "../../../styles/safeArea";
import {
  FilterItem,
  FilterWinesTitle,
  PricePointsCheckbox,
  SmallerCheckboxFilter,
} from "../../molecules/FilterWinesHolder/style";
import { FilterSectionTitle } from "../../atoms/StyledButtonWithUpAndDownArrows";

export const Form = styled.form`
  padding: 30px;
  ${safeAreaTopPaddingPlus(30)}

  ${breakpoints.smDown} {
    padding: 15px 20px;
    ${safeAreaTopPaddingPlus(15)}
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 35px;
`;

export const Title = styled(FilterWinesTitle).attrs({ as: "h2" })`
  font-size: 32px;
  margin: 0 !important;

  ${breakpoints.smDown} {
    display: block;
    font-size: 20px;
    letter-spacing: 0.5px;
    line-height: normal;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: 0;
  font-size: 32px;
  padding: 0 10px;
`;

export const FilterGroups = styled.div`
  margin-bottom: 20px;
`;

export const FilterGroup = styled(FilterItem).attrs({ as: "section", isOpen: true })`
  min-width: 0;
`;

export const GroupTitle = styled(FilterSectionTitle).attrs({ as: "h3" })`
  padding-top: 20px;
  margin-bottom: 20px !important;
`;

export const PointsOptions = styled(PricePointsCheckbox)`
  label {
    position: relative;
  }

  input {
    display: block;
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    visibility: visible;
    cursor: pointer;
    z-index: 1;
  }

  input:focus-visible + span::before {
    outline: 2px solid black;
    outline-offset: 3px;
  }
`;

export const Colour = styled(SmallerCheckboxFilter)`
  /* Keep the shared wine-filter chips reachable by keyboard. */
  input {
    display: block;
    visibility: visible;
    inset: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    cursor: pointer;
  }

  &:focus-within {
    outline: 2px solid black;
    outline-offset: 3px;
  }
`;

export const Footer = styled.div`
  display: flex;
  gap: 15px;

  button {
    flex: 1;
  }
`;
